/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-12-01",
    versionChannel: "nightly",
    buildDate: "2024-12-01T00:07:48.183Z",
    commitHash: "130385c564777eb8eab326ec083d76a20845f743",
};
